import { AppstoreAddOutlined, BellOutlined, UserAddOutlined } from "@ant-design/icons";
import { timestampToLocalTime } from "anka-endeavour";
import { Button, DatePicker, Form, Input, Select, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import DataTable from "../components/DataTable";
import Status from "../components/Status";
import UserContactDrawer from "../components/UserContactDrawer";
import { UsersTagBindingModal } from "../components/UsersTagBindingModal";
import { UserTagBindingModal } from "../components/UserTagBindingModal";
import { hostname } from "../hooks/useEndeavour";

function UsersPage() {
  const [forceUpdate, setForceUpdate] = useState(0);
  const drawerRef = useRef();
  const notificationsRef = useRef();
  const userTagBindingRef = useRef();
  const usersTagBindingRef = useRef();
  const [selected, setSelected] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onUpdateFeeGroup = () => {
    setForceUpdate(forceUpdate + 1);
  };

  const onClickContact = (data, multiple) => {
    drawerRef.current.openDrawer(data, multiple, setSelected);
  };

  useEffect(() => {
    if (selected.length > 0) {
      return;
    }
    setSelectedRowKeys([]);
  }, [selected]);

  return (
    <>
      <UserContactDrawer ref={drawerRef} onChange={onUpdateFeeGroup} setSelected={setSelected} />

      <UserTagBindingModal ref={userTagBindingRef} />
      <UsersTagBindingModal ref={usersTagBindingRef} selectedUser={selected} />
      <DataTable
        tableSize="small"
        uri={`${hostname}/pa-alliance/users`}
        ForceUpdate={forceUpdate}
        tableTitle={
          <Space>
            <Button
              type="primary"
              icon={<BellOutlined />}
              onClick={() => {
                onClickContact(selected, true);
              }}
            >
              Contact multiple users
            </Button>
            <Button
              icon={<UserAddOutlined />}
              type="primary"
              onClick={() => {
                usersTagBindingRef.current.showModal(selected);
              }}
            >
              Users banding tag
            </Button>
          </Space>
        }
        tableRowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: (rowKeys, rows) => {
            // console.log("rowKeys", rowKeys, rows);
            setSelected(rows);
            setSelectedRowKeys(rowKeys);
          },
        }}
        filters={[
          <Form.Item label="Email" name="email">
            <Input autoFocus allowClear />
          </Form.Item>,

          <Form.Item label="Email Status" name="email_verified">
            <Select
              allowClear
              options={[
                { label: "Verified", value: "1" },
                { label: "Not Verify", value: "0" },
              ]}
            />
          </Form.Item>,
          <Form.Item label="Mobile Status" name="mobile_verified">
            <Select
              allowClear
              options={[
                { label: "Verified", value: "1" },
                { label: "Not Verify", value: "0" },
              ]}
            />
          </Form.Item>,
          <Form.Item label="E-KYC Status" name="kyc_id">
            <Select
              allowClear
              options={[
                { label: "Verified", value: "1" },
                { label: "Not Verify", value: "0" },
              ]}
            />
          </Form.Item>,
          <Form.Item label="Card Binding Status" name="card">
            <Select
              allowClear
              options={[
                { label: "True", value: true },
                { label: "False", value: false },
              ]}
            />
          </Form.Item>,
          <Form.Item label="Contact Status" name="contact_status">
            <Select
              allowClear
              options={[
                {
                  value: "pending",
                  label: "Pending",
                },
                {
                  value: "Hello",
                  label: "Hello",
                },
                {
                  value: "Follow Up ",
                  label: "Follow Up",
                },
                {
                  value: "No Reply",
                  label: "No Reply",
                },
                {
                  value: "Escalate",
                  label: "Escalate",
                },
              ]}
            />
          </Form.Item>,
          <Form.Item label="Not Contacted Time" name="no_contacted_at">
            <Select
              allowClear
              options={[
                {
                  value: "30",
                  label: "30 Days",
                },
                {
                  value: "60",
                  label: "60 Days",
                },
                {
                  value: "90",
                  label: "90 Days",
                },
                {
                  value: "120",
                  label: "120 Days",
                },
                {
                  value: "360",
                  label: "360 Days",
                },
              ]}
            />
          </Form.Item>,
          <Form.Item label="Contacted Time" name="contacted_at">
            {/* <DatePicker style={{ width: '100%' }} /> */}

            <DatePicker.RangePicker />
          </Form.Item>,
        ]}
        tableColumns={[
          {
            title: "User",
            align: "center",
            render: (data) => {
              return (
                <a href={`/users/${data.id}`} target="_blank">
                  {data.email}
                </a>
              );
            },
          },
          {
            title: "First Name",
            align: "center",
            render: (data) => {
              if (data.first_name === null) {
                return "";
              }
              return data.first_name;
            },
          },
          {
            title: "Last Name",
            align: "center",
            render: (data) => {
              if (data.last_name === null) {
                return "";
              }
              return data.last_name;
            },
          },
          {
            title: "Mobile",
            align: "center",
            render: (data) => {
              return data.mobile;
            },
          },
          {
            title: "Email Verified",
            align: "center",
            render: (data) => {
              return <Status value={data.email_verified === false ? "FAILED" : "SUCCESS"} />;
            },
          },
          {
            title: "Mobile Verified",
            align: "center",
            render: (data) => {
              if (data.mobile_verified === null) {
                return <Status value={"PENDING"} />;
              }
              return <Status value={data.mobile_verified === false ? "FAILED" : "SUCCESS"} />;
            },
          },
          {
            title: "EKYC",
            align: "center",
            render: (data) => {
              if (data.kyc_id === null) {
                return <Status value={"PENDING"} />;
              }
              return <Status value={data.kyc_id === null ? "FAILED" : "SUCCESS"} />;
            },
          },
          {
            title: "Card Binding",
            align: "center",
            render: (data) => {
              if (data.card_binded === null) {
                return <Status value={"PENDING"} />;
              }

              return <Status value={data.card_binded === "0" ? "FAILED" : "SUCCESS"} />;
            },
          },
          {
            title: "Contacted Status",
            align: "center",
            render: (data) => {
              if (data.contact_status === null) {
                return <Status value={"pending"} />;
              }

              return <Status value={data.contact_status} />;
            },
          },
          {
            title: "Time",
            align: "center",
            render: (data) => {
              return timestampToLocalTime(data.created_at);
            },
          },
          {
            title: "Contacted Time",
            align: "center",
            render: (data) => {
              if (data.contacted_at === null) {
                return null;
              }
              return timestampToLocalTime(data.contacted_at);
            },
          },
          {
            title: "Action",
            align: "center",
            render: (data) => {
              return (
                <Space>
                  <Button type="primary" icon={<BellOutlined />} onClick={() => onClickContact(data.id, false)}>
                    Contacted User
                  </Button>
                  <Button type="primary" icon={<AppstoreAddOutlined />} onClick={() => userTagBindingRef.current.showModal(data.email)}>
                    Add tag
                  </Button>
                </Space>
              );
            },
          },
        ]}
      />
    </>
  );
}

export default UsersPage;
